<div class="key-info">
    <div class="info-card main-info">
        <sergeant-title [title]="'Nøkkelinfo'" (showMoreClicked)="onShowMoreKeyinfo()"></sergeant-title>
        <key-value-pair-list [keyValuePairs]="keyValuePairs()" [enableShowMore]="true"></key-value-pair-list>
    </div>

    <div class="secondary-info">
        <div class="area no-left-padding">
            <single-energy-label
                [energyRating]="energyLabel()"
                [isGreenHome]="keyInfoData().energyInfo.greenHome"
                [greenHomeDescription]="keyInfoData().energyInfo.greenHomeDescription"
                (expandDetailsClicked)="goToEnergyInformation()"
            ></single-energy-label>
        </div>
        <div class="area">
            <scoring [scoringValues]="score()"></scoring>
        </div>
        @if (hasPhysicalExposuresRole() && physicalExposures()?.totalPhysicalRiskScore > 0) {
            <div class="area">
                <key-info-physical-exposure
                    [physicalExposures]="physicalExposures()"
                    (expandDetailsClicked)="goToPhysicalExposures()"
                ></key-info-physical-exposure>
            </div>
        }
        @if (hasSpecialConstraintsRole()) {
            <div class="area">
                <key-info-special-constraints
                    [specialConstraints]="specialConstraints()"
                    (expandDetailsClicked)="goToSpecialConstraints()"
                ></key-info-special-constraints>
            </div>
        }
        @if (hasForeclosureDiscountRole() && foreclosureDiscount() != null) {
            <div class="area">
                <key-info-foreclosure-discount [foreclosureDiscount]="foreclosureDiscount()"></key-info-foreclosure-discount>
            </div>
        }
    </div>
    <div class="info-card image">
        <image-carousel [imagePackages]="imagePackages()" [estateType]="propertyImageClass()"></image-carousel>
    </div>
    <div class="info-card link-taskbar"><ev-link-taskbar [navigationMenuItems]="navigationMenuItems()"></ev-link-taskbar></div>
</div>
